export default {
    welcomeBack: 'مرحبًا بعودتك', /* any text, it is a comment */
    myTasks: 'مهامي',
    helloName: 'مرحبًا {name}!',
    thanksForFamily: 'شكرًا لانضمامك لدعم عائلة {family_name}.',
    alwaysReady: 'دائمًا مستعد للمساعدة!',
    progressBar: 'تم أخذ {part} من أصل {total} مهام',
    allTasks: 'جميع المهام',
    datelessTasks: 'مهام بدون تاريخ',
    iWillTakeIt: 'سأتولاها!',
    with_date: 'بتاريخ',
    dateless: 'بدون تاريخ',
    thanksForCaring: 'لا توجد كلمات تعبّر عن امتناننا. أفعالك تتحدث عنك. شكرًا!',
    percent38: ' ',
    setSms: 'أرسل لي تذكيرًا عبر SMS',
    addCalendar: 'إضافة إلى التقويم',
    cancel: 'إلغاء',
    submit: 'إرسال',
    monday: 'اث',
    tuesday: 'ثل',
    wednesday: 'أر',
    thursday: 'خم',
    friday: 'جم',
    saturday: 'سب',
    sunday: 'أح',

    monday_: 'اثن',
    tuesday_: 'ثلث',
    wednesday_: 'أرب',
    thursday_: 'خمي',
    friday_: 'جمع',
    saturday_: 'سبت',
    sunday_: 'أحد',

    january: 'يناير',
    february: 'فبراير',
    march: 'مارس',
    april: 'أبريل',
    may: 'مايو',
    june: 'يونيو',
    july: 'يوليو',
    august: 'أغسطس',
    september: 'سبتمبر',
    october: 'أكتوبر',
    november: 'نوفمبر',
    december: 'ديسمبر',

    translate: 'ترجمة',
    refuseYesNo: 'هل أنت متأكد أنك تريد الرفض؟',
    refuseIfYes: 'إذا نعم، يرجى توضيح السبب في الحقل أدناه.',
    yourAnswer: 'إجابتك',
    back: 'رجوع',
    confirm: 'تأكيد',
    areYouSure: 'هل أنت متأكد؟',
    didYouComplete: 'هل أنهيت المهمة فعلاً؟',
    yes: 'نعم',
    no: 'لا',

    noTaskThis: 'لا توجد مهام بالتاريخ المحدد، ولا توجد مهام بدون تاريخ أيضًا',
    noTaskTaken: 'لم تأخذ أي مهام بعد. يرجى الانتقال إلى صفحة المهام الرئيسية وأخذ بعض المهام',
    noTaskAvailable: 'لا توجد مهام متاحة. يرجى طلب إنشاء مهام من صاحب العائلة',

    errLoginTitle: 'يرجى تسجيل الدخول',
    //errLoginDescription: "",
    errAuthTitle: 'مصادقة خاطئة',
    errAuthDescription: 'هذه الصفحة تتطلب المصادقة ولكن الرموز المحفوظة غير صالحة. حاول تسجيل الدخول عبر SMS مرة أخرى',
    errLoadTitle: 'خطأ في الصفحة',
    errLoadDescription: 'حدث خطأ غير متوقع. يرجى التواصل مع الدعم',
    errNetworkTitle: 'غير متاح',
    errNetworkDescription: 'يرجى التحقق من اتصال الإنترنت وإعادة تحميل الصفحة',
    errServerTitle: 'مشكلة في الخادم',
    errServerDescription: 'يرجى المحاولة لاحقًا',

    decline: 'رفض',
    done: 'تم',
    onlyDatelessStr: 'لا توجد مهام لليوم الحالي، ولكن يمكنك أيضًا القيام بما يلي اليوم:',
    datelessStr: 'يمكنك أيضًا القيام بما يلي اليوم:',
    viewDetails: 'عرض التفاصيل',
    taken: 'مأخوذة',
    noDescriprion: 'لا يوجد وصف',
    tryAgain: 'حاول مرة أخرى',
    happyJourney: 'سعداء بانضمامك\nإلى رحلتنا',
    notForMe: 'انسحاب',
    mytasks: 'مهامي',
    signUp: 'التسجيل',
    wNumber: 'ما هو رقم هاتفك؟',
    wName: 'ما اسمك؟',
    greatTo: 'سعداء بوجودك معنا',
    anyHelp: 'أي مساعدة تقدمها،\nستحدث فرقًا',
    scrollToAgree: 'مرر للموافقة',
    ok_scroll: 'موافق',

    howCanI: 'كيف يمكنني المساعدة',
    anyTaskTake: 'أي مهمة تأخذها ستساعد',
    noTaskYet: 'لا توجد مهام بعد',

    welcomeBackName: 'مرحبًا {first_name}!',
    helpingToFamily: ' دعم ',

    goBack: 'العودة',

    completed_: 'مكتملة',
    unassigned_: 'غير معيّنة',
    taken_: 'مأخوذة',
    notiTaskCompleted: 'تم إكمال المهمة "{taskName}"',
    notiTaskUnassigned: 'تم إلغاء تعيين المهمة "{taskName}"',
    notiTaskTaken: 'تم أخذ المهمة "{taskName}"',

    set_: 'تعيين',
    pleasePickTime: 'يرجى اختيار الوقت',
    pickDate: 'اختر التاريخ',
    pickTime: 'اختر الوقت',
    itsTimeFor: 'حان وقت Apple/Google Calendar لـ',

    signingIn_1: 'يشكّل تسجيل الدخول تأكيدًا على ',
    termsOfUse: 'شروط الاستخدام',
    signingIn_2: ' و ',
    privacyPolicy: 'سياسة الخصوصية',
    signingIn_3: '، التي تحافظ على كرامة العائلة وتحسّن المساعدة',
    thisIsYourTask: 'هذه هي مهمتك',

    switchAccounts: 'تبديل الحسابات',
    switch: 'تبديل',
    logout: 'تسجيل الخروج',
    current: 'الحالي',
    help: 'مساعدة',

    signUpRequestError: 'خطأ في طلب التسجيل',
    pleaseEnterValidPhone: 'يرجى إدخال رقم هاتف صالح وموجود',
    youAreRegistered: 'أنت مسجّل بالفعل في العائلة. يرجى العثور على رابط تسجيل الدخول في رسالة SMS',
    family: 'العائلة',

    showInMyTasks: 'إظهار في مهامي',

    menu_all_tasks: 'جميع المهام',
    menu_my_tasks: 'مهامي',
    menu_profile: 'الملف الشخصي',

    button_Today: 'اليوم',

    widget_tasks_available: 'المهام المتاحة',
    widget_tasks_taken: 'المهام المأخوذة',

    neverLoseThisPage: 'لا تفقد هذه الصفحة ولا تفوّت أي فرصة للدعم.',
    install_iOS: 'الحصول على التطبيق',
    install_Android: 'تحميل apk',
    install_PWA: 'تثبيت PWA',
    install_AddToHome: 'أضف تطبيقنا إلى الشاشة الرئيسية.',
    install_App: 'تثبيت تطبيقنا.',

    button_MyTask: 'مهمتي',

    category_home: 'المنزل',
    category_medical: 'طبي',
    category_childcare: 'رعاية الأطفال',
    category_finance: 'مالي',
    category_legal_rights: 'الحقوق القانونية',
    category_emotional: 'دعم عاطفي',

    category_legal: 'الحقوق القانونية',
    category_general: 'عام',

    language: 'اللغة',

    demoAccount: 'حساب تجريبي',
    thisRequiresAuth: 'هذه الصفحة تتطلب المصادقة.',

    thankForChoosing: 'شكرًا لاختيارك دعم\nعائلة {family_name}',

    theFamilyMappedOutTasks: 'قامت العائلة بتحديد المهام التي يمكن أن تدعمها. كل ما تبقى عليك هو الدخول واختيار المهام',

    everySmallTask: 'كل مهمة صغيرة تُحدث فرقًا كبيرًا.',
    letsStart: 'لنبدأ',

    weEstablishedEnolaTo: 'أنشأنا Tamar لمساعدة العائلات في الأوقات الصعبة وتفعيل شبكة الدعم من حولهم بكفاءة.',

    thankYouForWantedToSupport: 'شكرًا لرغبتك في دعم عائلة {family_name}',
    wasSentToFamilly: '{full_name}، تم إرسال طلبك للانضمام إلى دائرة الدعم لعائلة {family_name}. نظرًا لحساسية هذا الوقت، قد يستغرق الأمر بعض الوقت.',
    //
    continue: 'متابعة',
    supportForTheFamily: 'دعم عائلة {family_name}',
    yourRequestSentToTheFamily: 'تم إرسال طلبك للانضمام إلى دائرة الدعم للعائلة. شكرًا جزيلًا لاهتمامك :)',
    //
    inspiredBy: 'مستوحى من',
    youShouldRegister: 'للحفاظ على خصوصية العائلة، يجب عليك التسجيل في هذا النظام.',
    afterRegistration: 'بعد التسجيل يمكنك أخذ مهمة بعد موافقة العائلة.',
    someTasksFrom: 'بعض المهام من ',

    regConditions_0: 'قبل أن نبدأ، ونظرًا لحساسية نشاطنا، يرجى أخذ لحظة لقراءة والموافقة على ',
    regConditions_url_0: 'شروط الاستخدام',
    regConditions_1: ' و ',
    regConditions_url_1: 'سياسة الخصوصية',
    regConditions_2: ' المصممتين لحماية العائلة وتعظيم الدعم لها. النقر على الزر يؤكد أنك قرأت ووافقت.',

    iCannotTake: 'لا أستطيع أخذ هذه المهمة',
    scheduledFor: 'مجدولة لـ: ',
    taskToCalendar: 'إضافة المهمة إلى التقويم طريقة جيدة لتتبعها.',
    iWillTake: 'سآخذ المهمة',

    sendMessage: 'إرسال رسالة',
    sendWhatsApp: 'إرسال رسالة واتساب',
    forMoreDetails: 'لمزيد من التفاصيل:',
    tasks: 'مهام',

    tab_all: 'الكل',
    tab_available: 'متاحة',
    tab_my: 'خاصتي',
    finished: 'منتهية',

    profile_takenTasks: 'المهام المأخوذة',
    profile_CompletedTasks: 'المهام المكتملة',
    profile_logout: 'تسجيل الخروج من هذا الجهاز',
    profile_allMy: 'جميع مهامي',

    iWillDo: 'سأنفذها',
    description: 'الوصف',

    calendarItalic: 'لضمان تذكرك، يرجى إضافة هذه المهمة إلى التقويم',

    tasks_Taken: 'مأخوذة',

    any_time: 'أي وقت',

    contactForLink: 'تواصل مع صاحب العائلة واستلم رابط التسجيل',
    signUpFillTheForm: 'التسجيل (املأ النموذج عبر رابط التسجيل، يمكنك عرض بعض مهام العائلة قبل تعبئة النموذج)',
    clickOnLoinLink: 'انقر على رابط تسجيل الدخول (سيتم إرساله بعد تأكيد التسجيل) في رسالة SMS (إذا كان التطبيق مثبتًا، سيتم تسجيل دخولك تلقائيًا)',
    ifTryDemo: 'إذا كنت ترغب بتجربة التطبيق بدون تسجيل، يمكنك استخدام الحساب التجريبي (فقط اضغط على الزر أدناه)',
    yHaveTo: 'عليك أن:',

    withdrawBtnText: 'انسحاب',
    whyQuestion: 'هل يمكنك إخبارنا بالسبب؟',
    ifYesReason: 'إذا نعم، يرجى وصف السبب:',
    areYouQuestion: 'هل أنت متأكد أنك تريد إلغاء تعيين نفسك من هذه المهمة؟',

    welcomeToApp: 'مرحبًا بك في تطبيق Tamar',
    youAreInvitedBy: '{familyName} دعتك للمساعدة في وقت صعب. اختر المهام لدعمهم وبناء مجتمع متكاتف',
    letsGo: 'لننطلق',

    startAt: 'يبدأ في:',
    endAt: 'ينتهي في:',

    thanksHeader: 'شكرًا لانضمامك لدائرة الدعم لعائلة {family_name}.',
    thanksText: 'ستصلك رسائل قريبًا تحتوي على الاحتياجات والمهام المطلوبة. كل مساعدة، مهما كانت صغيرة، تُقدّر جدًا🙏',
    nameInTxt: 'الاسم',
    nameInTxt2: 'اسم العائلة',
    phoneInTxt: 'رقم الهاتف',
    iHaveReadWelcome_1: 'لقد قرأت ووافقت على ',
    iHaveReadWelcome_2: ' و ',
    iHaveReadWelcome_3: ' للمساعدة في حماية العائلة وضمان أقصى دعم.',
    thanksFamily: 'شكرًا لانضمامك لدائرة الدعم لعائلة {familyName}',

    langSwitchHeader: 'تغيير اللغة',
    langSwitchSubtitle: 'ما هي اللغة التي تفضل؟',

    otpVerification: 'التحقق بالرمز',
    otpCodeSent: 'أدخل الرمز المرسل إلى هاتفك',


} as const;

